import assetcorrelations_ from 'assets/img/landing-icons/co-asset-correlations.png';
import correlationmatrix_ from 'assets/img/landing-icons/co-correlation-matrix.png';
import rollingcorrelation_ from 'assets/img/landing-icons/co-rolling-correlation.png';
import RollingCorrelation from './RollingCorrelation';
import CorrelationMatrix from './CorrelationMatrix';
import AssetCorrelations from './AssetCorrelations';
import HorizontalLanding from 'components/HorizontalLanding';

export const meta = {
  path: '/co',
  title: 'Correlation Hub',
  component: Landing,
  items: [
    {
      path: '/asset-correlations',
      title: 'Asset Correlations',
      component: AssetCorrelations,
      description: 'Visualize the correlation of an asset to major asset classes over various time intervals.',
      imgSrc: assetcorrelations_,
      permission: 'co-asset-correlations',
    },
    {
      path: '/correlation-matrix',
      title: 'Correlation Matrix',
      component: CorrelationMatrix,
      description: 'Generate a cross-correlation heatmap and dynamically adjust over various time intervals.',
      imgSrc: correlationmatrix_,
      permission: 'co-correlation-matrix',
    },
    {
      path: '/rolling-correlation',
      title: 'Rolling Correlation',
      component: RollingCorrelation,
      description:
        'Perform dynamic analysis of the correlation trend for any two assets over a series of rolling time windows.',
      imgSrc: rollingcorrelation_,
      permission: 'co-rolling-correlation',
    },
  ],
};

export default function Landing({ session }) {
  return <HorizontalLanding meta={meta} session={session} className="tw-max-w-7xl" />;
}
